import script from "./ChooseProjectForUploadModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChooseProjectForUploadModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChooseProjectForUploadModal.vue?vue&type=style&index=0&id=350946fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350946fc"]])

export default __exports__